import { capitalize } from "@datassential/platform-ui-lib";
import { ConsumerKeyword, ConsumerDemographicCohort } from "@models/ConsumerData";
import { ChartOption, Series } from "@components/GroupsColumnsLineChart/GroupsColumnsLineChart";
import { DataColumn } from "@pages/CategoryProfile/components/CategoryProfileDataColumns/CategoryProfileDataColumns";
import { CONSUMER_SERIES_COLORS, TREND_CHART_QUARTERS } from "./Consumer.constants";

export interface TrendChartData {
    series: Series[];
    groups: ChartOption[];
    columns: ChartOption[];
}

export function buildTrendChart(keywords: ConsumerKeyword[]): TrendChartData {
    const years = keywords
        .flatMap(keyword => keyword.trend.map(point => point.year))
        .filter((year, index, all) => all.indexOf(year) === index)
        .sort((a, b) => a - b);

    const groups: ChartOption[] = years.map(year => ({ id: String(year), title: String(year) }));

    const series: Series[] = keywords.map((keyword, index) => ({
        id: keyword.id,
        title: capitalize(keyword.name),
        color: CONSUMER_SERIES_COLORS[index % CONSUMER_SERIES_COLORS.length],
        values: keyword.trend.map(point => ({
            groupId: String(point.year),
            columnId: `q${point.quarter}`,
            value: point.value,
        })),
    }));

    return { series, groups, columns: TREND_CHART_QUARTERS };
}

export function buildAffinityColumns(cohorts: ConsumerDemographicCohort[]): DataColumn[] {
    return cohorts.map(cohort => ({
        label: cohort.name,
        testId: `blockCategoryProfileConsumerAffinity-${cohort.id}`,
        items: cohort.items.map(item => ({
            name: capitalize(item.name),
            value: Math.round(item.index),
        })),
    }));
}
